import React from 'react';

function Footer({ resumeData }) {
  if (!resumeData) {
    return null;
  }

  const currentYear = new Date().getFullYear();
  const { socialLinks, name } = resumeData;

  return (
    <footer>
      <div className="row">
        <div className="twelve columns">
          <ul className="social-links">
            {socialLinks && socialLinks.map((link, index) => (
              <li key={index}>
                <a 
                  href={link.url} 
                  target="_blank" 
                  rel="noopener noreferrer"
                  aria-label={link.name}
                >
                  <i className={link.className} />
                </a>
              </li>
            ))}
          </ul>
          <ul className="copyright">
            <li>© Copyright {currentYear} {name}</li>
            <li>Design by <a href="#name" title={`${name} Choi`}>{name} Choi</a></li>
          </ul>
        </div>
        <div id="go-top">
          <a className="smoothscroll" title="Back to Top" href="#home">
            <i className="icon-up-open" />
          </a>
        </div>
      </div>
    </footer>
  );
}

export default Footer;